/**
 * Mobile full-screen search overlay for Habitat style4 header.
 * Opens when the collapsed mobile search control is activated.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var searchArea = document.querySelector('.header.style4 .header-search-area');
    if (!searchArea) return;

    var overlay = document.createElement('div');
    overlay.className = 'nodus-mobile-search';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="nodus-mobile-search__panel" role="dialog" aria-modal="true" aria-label="Search">' +
      '  <div class="nodus-mobile-search__bar">' +
      '    <button type="button" class="nodus-mobile-search__close" aria-label="Close search">&times;</button>' +
      '    <form class="nodus-mobile-search__form" action="/search" method="get" role="search">' +
      '      <input type="search" name="q" class="nodus-mobile-search__input" placeholder="Search products, blanks, films…" autocomplete="off" enterkeyhint="search" />' +
      '    </form>' +
      '  </div>' +
      '  <div class="nodus-mobile-search__body">' +
      '    <div class="nodus-mobile-search__idle">' +
      '      <p class="nodus-mobile-search__label">Popular searches</p>' +
      '      <div class="nodus-mobile-search__chips" data-popular></div>' +
      '      <p class="nodus-mobile-search__label">Recent searches</p>' +
      '      <div class="nodus-mobile-search__chips" data-recent></div>' +
      '    </div>' +
      '    <div class="nodus-mobile-search__results thb-quick-search--results" hidden></div>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(overlay);

    var input = overlay.querySelector('.nodus-mobile-search__input');
    var results = overlay.querySelector('.nodus-mobile-search__results');
    var idle = overlay.querySelector('.nodus-mobile-search__idle');
    var popular = overlay.querySelector('[data-popular]');
    var recent = overlay.querySelector('[data-recent]');
    var closeBtn = overlay.querySelector('.nodus-mobile-search__close');
    var popularTerms = ['gang sheet', 'UV sticker', 'glitter', 't-shirt', 'hoodie', 'sample pack', 'heat tape'];
    var storageKey = 'dtftown_recent_searches';

    function chips(container, terms) {
      container.innerHTML = '';
      (terms || []).forEach(function (term) {
        var a = document.createElement('a');
        a.href = '/search?q=' + encodeURIComponent(term);
        a.className = 'nodus-mobile-search__chip';
        a.textContent = term;
        container.appendChild(a);
      });
      if (!terms || !terms.length) {
        container.innerHTML = '<span class="nodus-mobile-search__empty">No recent searches yet</span>';
      }
    }

    function getRecent() {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '[]');
      } catch (e) {
        return [];
      }
    }

    function pushRecent(term) {
      term = (term || '').trim();
      if (!term) return;
      var list = getRecent().filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      });
      list.unshift(term);
      localStorage.setItem(storageKey, JSON.stringify(list.slice(0, 8)));
    }

    chips(popular, popularTerms);
    chips(recent, getRecent());

    function open() {
      if (window.innerWidth > 1068) return;
      overlay.removeAttribute('hidden');
      document.documentElement.classList.add('nodus-mobile-search-open');
      chips(recent, getRecent());
      setTimeout(function () {
        input.focus();
      }, 50);
    }

    function close() {
      overlay.setAttribute('hidden', '');
      document.documentElement.classList.remove('nodus-mobile-search-open');
      input.value = '';
      results.innerHTML = '';
      results.hidden = true;
      idle.hidden = false;
    }

    searchArea.addEventListener('click', function (e) {
      if (window.innerWidth > 1068) return;
      e.preventDefault();
      open();
    });

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) close();
    });

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        results.hidden = true;
        idle.hidden = false;
        return;
      }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8')
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            var collections = (((data || {}).resources || {}).results || {}).collections || [];
            var html = '';
            if (collections.length) {
              html += '<p class="nodus-mobile-search__label">Collections</p><ul class="nodus-mobile-search__list">';
              collections.slice(0, 4).forEach(function (c) {
                html +=
                  '<li><a href="' +
                  c.url +
                  '"><span>' +
                  (c.title || '') +
                  '</span></a></li>';
              });
              html += '</ul>';
            }
            if (products.length) {
              html += '<p class="nodus-mobile-search__label">Products</p><ul class="nodus-mobile-search__list">';
              products.forEach(function (p) {
                var img = p.image || '';
                var price = p.price ? p.price : '';
                html +=
                  '<li><a href="' +
                  p.url +
                  '">' +
                  (img ? '<img src="' + img + '" alt="" width="48" height="48" loading="lazy">' : '') +
                  '<span><strong>' +
                  (p.title || '') +
                  '</strong>' +
                  (price ? '<em>' + price + '</em>' : '') +
                  '</span></a></li>';
              });
              html += '</ul>';
            }
            if (!html) {
              html =
                '<p class="nodus-mobile-search__empty">We couldn\'t find that, but here\'s what people usually look for</p>';
              chips(popular, popularTerms);
            }
            results.innerHTML = html;
            results.hidden = false;
            idle.hidden = true;
          })
          .catch(function () {
            /* ignore network errors in overlay */
          });
      }, 220);
    });

    overlay.querySelector('.nodus-mobile-search__form').addEventListener('submit', function () {
      pushRecent(input.value);
    });
  });
})();
